// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2gC5r","col":"styles_col__1r9T5"};